import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
// import {
//     faAlignRight, faAlignLeft, faVideo,
// } from '@fortawesome/free-solid-svg-icons';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import A1GA from '../../../helpers/A1GA';
import Button from '../../../common/button/Button';
// import ArtistsSlider from '../../artists/containers/ArtistsSliderContainer';
import Spinner from '../../../common/Spinner/Spinner';
import MusicCardContainer from '../containers/MusicCardContainer';

export default class MusicsPageComponent extends Component {
    constructor(props) {
        super(props);

        const params = queryString.parse(this.props.location.search);
        const { busca, letra, traducao, video } = params;
        const initialFilterOptions = {
            filterForLyrics: letra === 'true',
            filterForTranslation: traducao === 'true',
            filterForVideos: video === 'true',
            filterForQuery: busca || '',
        };

        this.state = {
            filterForLyrics: initialFilterOptions.filterForLyrics,
            filterForTranslation: initialFilterOptions.filterForTranslation,
            filterForVideos: initialFilterOptions.filterForVideos,
            filterForQuery: initialFilterOptions.filterForQuery,
            lastFilterOptions: initialFilterOptions,
            filterForQueryValue: initialFilterOptions.filterForQuery,
            isTyping: false,
        };

        this.queryFilterHandle = false;
    }

    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        if (this.props.location.search) {
            this._logFilterOnGA();

            // prepare filter options
            const filterOptions = {
                filterForLyrics: this.state.filterForLyrics,
                filterForTranslation: this.state.filterForTranslation,
                filterForVideos: this.state.filterForVideos,
                filterForQuery: this.state.filterForQuery,
            };

            return this._getFilteredMusics(20, 0, filterOptions);
        }

        return this.props.getMusicDataIfNeeded(20, 0);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.musicsPageData !== this.props.musicsPageData ||
            nextProps.filteredMusics !== this.props.filteredMusics ||
            nextProps.isLoading !== this.props.isLoading ||
            nextProps.noMoreMusics !== this.props.noMoreMusics ||
            nextProps.noMoreFilteredMusics !== this.props.noMoreFilteredMusics ||
            nextState.filterForLyrics !== this.state.filterForLyrics ||
            nextState.filterForTranslation !== this.state.filterForTranslation ||
            nextState.filterForVideos !== this.state.filterForVideos ||
            nextState.filterForQuery !== this.state.filterForQuery ||
            nextState.filterForQueryValue !== this.state.filterForQueryValue ||
            nextState.isTyping !== this.state.isTyping;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterForLyrics !== this.state.filterForLyrics ||
           prevState.filterForTranslation !== this.state.filterForTranslation ||
           prevState.filterForVideos !== this.state.filterForVideos ||
           prevState.filterForQuery !== this.state.filterForQuery) {
            // update the query in the url
            if (this._filterApplied()) {
                this._logFilterOnGA();

                this.props.history.push(`/musicas?letra=${this.state.filterForLyrics}&traducao=${this.state.filterForTranslation}&video=${this.state.filterForVideos}&busca=${encodeURIComponent(this.state.filterForQuery)}`);
            } else {
                this.props.history.push('/musicas');
            }

            if (this._filterApplied()) {
                // if there is any filter applied, check if it is different from the last filter
                if (this.state.lastFilterOptions.filterForLyrics !== this.state.filterForLyrics ||
                    this.state.lastFilterOptions.filterForTranslation !== this.state.filterForTranslation ||
                    this.state.lastFilterOptions.filterForVideos !== this.state.filterForVideos ||
                    this.state.lastFilterOptions.filterForQuery !== this.state.filterForQuery) {
                    // prepare filter options
                    const filterOptions = {
                        filterForLyrics: this.state.filterForLyrics,
                        filterForTranslation: this.state.filterForTranslation,
                        filterForVideos: this.state.filterForVideos,
                        filterForQuery: this.state.filterForQuery,
                    };

                    this._getFilteredMusics(20, 0, filterOptions);
                }
            } else {
                this.props.getMusicDataIfNeeded(20, 0);
            }
        }
    }

    _filterApplied = () => this.state.filterForLyrics ||
        this.state.filterForTranslation ||
        this.state.filterForVideos ||
        !!this.state.filterForQuery

    _mapMusicsPageData = (musics) => {
        if (this._filterApplied() && musics.length === 0 && this.props.isLoading) {
            // we are still waiting for the filtered data
            return null;
        }

        if (this._filterApplied() && musics.length === 0) {
            // no (more) filtered data found
            return (
                <p className="noContentWarning md:tw-absolute md:tw-left-20 lg:tw-left-48 xl:tw-left-56" key="No content">
                    Nenhuma música foi encontrada para esse filtro :(
                    <br />
                    Gostaria de entrar em
                    {' '}
                    <Button title="Entre em contato" to="/contato" className="TextLink">contato</Button>
                    {' '}
                    para nos dizer qual música está faltando?
                </p>
            );
        }

        return musics.map((music, index) => <MusicCardContainer
            music={music}
            key={music.musicId}
            // playlist
            playlistType="musicsPage"
            playlistData={this.props.musicsPageData}
            musicIndex={index}
            useFilteredMusics={this._filterApplied()}
        />);
    }

    _getFilteredMusics = (num, init, options) => {
        // prepare the options object for the api
        const cleanOptions = {
            lyrics: options.filterForLyrics && true,
            translation: options.filterForTranslation && true,
            video: options.filterForVideos && true,
            query: options.filterForQuery !== '' ? options.filterForQuery : false,
        };

        this.props.getFilteredMusicDataIfNeeded(num, init, cleanOptions);

        // save the new filter
        this.setState(() => ({
            lastFilterOptions: {
                filterForLyrics: options.filterForLyrics,
                filterForTranslation: options.filterForTranslation,
                filterForVideos: options.filterForVideos,
                filterForQuery: options.filterForQuery,
            },
        }));
    }

    _logFilterOnGA = () => {
        // log the filters applied to analytics
        A1GA.event({
            category: 'MusicSearch',
            action: 'search_performed',
            label: `searchTerm:${this.state.filterForQuery}, lyrics:${this.state.filterForLyrics}, translation:${this.state.filterForTranslation}, video:${this.state.filterForVideos}`,
        });
    }

    _loadMoreMusics = () => {
        if (!this.props.isLoading && this._filterApplied() && this.props.filteredMusics.length !== 0) {
            if (!this.props.noMoreFilteredMusics) {
                // prepare filter options
                const filterOptions = {
                    filterForLyrics: this.state.filterForLyrics,
                    filterForTranslation: this.state.filterForTranslation,
                    filterForVideos: this.state.filterForVideos,
                    filterForQuery: this.state.filterForQuery,
                };

                this._getFilteredMusics(20, this.props.filteredMusics.length, filterOptions);
            }
        } else if (!this.props.isLoading && this.props.musicsPageData.length !== 0) {
            if (!this.props.noMoreMusics) {
                this.props.getMusicDataIfNeeded(20, this.props.musicsPageData.length);
            }
        }
    }

    _handleSearchInput = (event) => {
        // set isTyping to show the spinner already while typing
        this.setState({
            isTyping: true,
            filterForQueryValue: event.target.value,
        });

        // The following code sets a debounce for the query to avoid
        // multiple requests while typing on search field.
        clearTimeout(this.queryFilterHandle);

        this.queryFilterHandle = setTimeout(() => {
            this.setState((previousState) => ({
                isTyping: false,
                filterForQuery: previousState.filterForQueryValue,
            }));
        }, 700);
    }

    render() {
        const showLoadMoreButton = this._filterApplied() ? !this.props.noMoreFilteredMusics : !this.props.noMoreMusics;
        const musicData = this._filterApplied() ? this.props.filteredMusics : this.props.musicsPageData;

        return (
            <div className="musicsPageSection">
                <div className="musicsPageContainer">
                    <header>
                        <h1>Músicas</h1>
                        <p className="tw-text-black tw-text-center">Confira nosso acervo completo de músicas</p>
                    </header>
                    <div className="searchField tw-relative">
                        <input
                            value={this.state.filterForQueryValue}
                            onChange={this._handleSearchInput}
                            className="form-control"
                            placeholder="Pesquisar"
                            type="text"
                        />
                        <FontAwesomeIcon className="search-icon" icon={faSearch} width="40px" />
                    </div>
                    {/* <div className="filterButtons">
                        <Button
                            className="filterIcon"
                            title="Filtrar por Letra disponível"
                            onClick={() => this.setState((prevState) => ({ filterForLyrics: !prevState.filterForLyrics }))}
                        >
                            <FontAwesomeIcon icon={faAlignRight} width="16" className={this.state.filterForLyrics ? '' : 'filterNotApplied'} />
                            <br />
                            Letra
                        </Button>
                        <Button
                            className="filterIcon"
                            title="Filtrar por Tradução disponível"
                            onClick={() => this.setState((prevState) => ({ filterForTranslation: !prevState.filterForTranslation }))}
                        >
                            <FontAwesomeIcon icon={faAlignLeft} width="16" className={this.state.filterForTranslation ? '' : 'filterNotApplied'} />
                            <br />
                            Tradução
                        </Button>
                        <Button
                            className="filterIcon"
                            title="Filtrar por Vídeo disponível"
                            onClick={() => this.setState((prevState) => ({ filterForVideos: !prevState.filterForVideos }))}
                        >
                            <FontAwesomeIcon icon={faVideo} width="16" className={this.state.filterForVideos ? '' : 'filterNotApplied'} />
                            <br />
                            Vídeos
                        </Button>
                    </div> */}
                    {
                        this.state.isTyping ?
                            <div className="centerText tw-m-auto">
                                <Spinner />
                            </div>
                            : [
                                <div key="musics-grid" className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-12 tw-relative">
                                    {this._mapMusicsPageData(musicData)}
                                </div>,
                                this.props.isLoading ?
                                    <div key="spinner-div" className="centerText tw-m-auto">
                                        <Spinner />
                                    </div>
                                    : showLoadMoreButton && <Button className="LoadMoreMusics" key="load-more-musics" title="Carregar mais músicas" onClick={() => this._loadMoreMusics()}>Ver Mais</Button>,
                            ]
                    }
                </div>
                {/* <ArtistsSlider withTitle /> */}
            </div>
        );
    }
}

MusicsPageComponent.propTypes = exact({
    musicsPageData: PropTypes.arrayOf(
        PropTypes.shape({
            musicId: PropTypes.number.isRequired,
            hasMusicTranslation: PropTypes.number.isRequired,
            musicTrack: PropTypes.string,
            lyricsVideo: PropTypes.string,
            albumCover: PropTypes.string,
            iTunesLink: PropTypes.string,
            musicName: PropTypes.string.isRequired,
            musicSlug: PropTypes.string.isRequired,
            artistName: PropTypes.string.isRequired,
            artistSlug: PropTypes.string.isRequired,
            musicVideo: PropTypes.string,
            albumName: PropTypes.string,
            hasMusicLyrics: PropTypes.number.isRequired,
        }),
    ),
    filteredMusics: PropTypes.arrayOf(
        PropTypes.shape({
            musicId: PropTypes.number.isRequired,
            hasMusicTranslation: PropTypes.number.isRequired,
            musicTrack: PropTypes.string,
            lyricsVideo: PropTypes.string,
            albumCover: PropTypes.string,
            iTunesLink: PropTypes.string,
            musicName: PropTypes.string.isRequired,
            musicSlug: PropTypes.string.isRequired,
            artistName: PropTypes.string.isRequired,
            artistSlug: PropTypes.string.isRequired,
            musicVideo: PropTypes.string,
            albumName: PropTypes.string,
            hasMusicLyrics: PropTypes.number.isRequired,
        }),
    ),
    isLoading: PropTypes.bool.isRequired,
    noMoreMusics: PropTypes.bool.isRequired,
    noMoreFilteredMusics: PropTypes.bool.isRequired,
    getMusicDataIfNeeded: PropTypes.func.isRequired,
    getFilteredMusicDataIfNeeded: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    match: PropTypes.object,
    staticContext: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});
